// You can customize the template with the help of this file

//Template config options
const themeConfig = {
  app: {
    // appName: 'DRONESYS',
    // appLogoImage: require('@src/assets/images/logo/logo.svg').default,
    //  appLogoImage: require('../assets/images/pal_logo.png').default
    appName: '인천테크노파크',
    appLogoImage: require('../assets/images/itp_logo_wh_icon.png').default
  },
  layout: {
    isRTL: false,
    skin: 'dark', // light, dark, bordered, semi-dark
    routerTransition: 'fadeIn', // fadeIn, fadeInLeft, zoomIn, none or check this for more transition https://animate.style/
    type: 'vertical', // vertical, horizontal
    contentWidth: 'full', // full, boxed
    menu: {
      isHidden: false,
      isCollapsed: true
    },
    navbar: {
      // ? For horizontal menu, navbar type will work for navMenu type
      type: 'sticky', // static , sticky , floating, hidden
      backgroundColor: 'white' // BS color options [primary, success, etc]
    },
    footer: {
      type: 'hidden' // static, sticky, hidden
    },
    customizer: false,
    scrollTop: true // Enable scroll to top button
  }
};

export default themeConfig;
